//main
import ContentFormatXC from "../content/webc/content-format-xc";

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import TokensListModule from "../content/tokens/tokens-list";

import { UserForm } from "../services/srvc-utilities";

export default function Tokens() {

  return (
  <>
    <ContentFormatXC 
      head='Credentials'
      link={`/${UserForm()}/home`}
      form= 'small'
      data= {
        <>
          <WebbDividerSmall />
          <TokensListModule />

        </>
      } 
    />
  </>
  )
}